import { useMemo } from 'react'
import { useDropzone } from 'react-dropzone'

import { useWarningStore } from '../../Stores/warningStore'
import { t } from '../../i18n'
import { UploadIcon } from '../Icons'
import { Container, acceptStyle, focusedStyle, rejectStyle } from './styles'

type DropzoneProps = {
  onChange: (files: any) => void
}

const TenMegaInBytes = 10000000

export const Dropzone = ({ onChange }: DropzoneProps) => {
  const { setWarningOptions } = useWarningStore()

  const convertToBase64 = (file: File) => {
    const reader = new FileReader()
    reader.readAsDataURL(file) //TODO: readAsDataURL to base64
    reader.onload = function (event) {
      onChange({
        ...file,
        name: file.name,
        type: file.type,
        content: (event.target?.result?.toString() || '').split(',')[1],
      })
    }
  }

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      maxSize: TenMegaInBytes,
      maxFiles: 1,
      accept: {
        'image/png': ['.png'],
        'image/jpeg': ['.jpeg', '.jpg'],
        'image/bmp': ['.bmp'],
        'image/tiff': ['.tif'],
        'application/pdf': ['.pdf'],
      },
      onDropAccepted: (files) => {
        files.map((file) => convertToBase64(file))
      },
      onDropRejected: () => {
        setWarningOptions({
          labelTypes: [t('pages.step7.attachmentDocuments.errors.invalid')],
        })
      },
    })

  const style = useMemo(
    () => ({
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  )

  return (
    <Container>
      <section className="container">
        <div {...getRootProps({ className: 'dropzone', style })}>
          <input {...getInputProps()} />
          <div className="info">
            <UploadIcon />
            <h4>{t('pages.step7.attachmentDocuments.dropzone.title')}</h4>
            <p>{t('pages.step7.attachmentDocuments.dropzone.description')}</p>
          </div>
        </div>
      </section>
    </Container>
  )
}
